import React from "react";
import { FaGithub } from "react-icons/fa";

import "./style.scss";
import trLogo from "../images/trLogo.png";
import gpiLogo from "../images/gpiLogo.png";
import { Link } from "gatsby";

const Navbar = () => (
  <div className="container-header">
    <div className="hero-head is-hidden-mobile ">
      <nav className="navbar is-transparent">
        <div className="container">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item">
              <img src={trLogo} width="130px" />
            </Link>
            <a className="navbar-item">
              <img src={gpiLogo} />
            </a>
          </div>
        </div>
      </nav>
    </div>
  </div>
);

export default Navbar;
